/**
 * 编写几个函数,用来生成标准的空结构体
 */

import {
    ImageMessageDefaultType,
    MessageType,
    TextMessageDefaultType,
} from '../interface'

export function createEmptyTextMessage(): TextMessageDefaultType {
    return {
        key: Date.now(),
        type: MessageType.TEXT,
        content: '',
    }
}

export function createEmptyImageMessage(src?: string): ImageMessageDefaultType {
    return {
        key: Date.now(),
        type: MessageType.IMAGE,
        img_url: src || '',
    }
}
